import { BonusSettlementType } from './bonus-settlement-type';

export enum BonusSettlementStatus {
    Draft = 'DRAFT',
    Sent = 'SENT',
    ReadyToComplete = 'READY_TO_COMPLETE',
    Completed = 'COMPLETED',
    Pending = 'PENDING',
}

const translationObject: { [Key in BonusSettlementStatus]: string } = {
    [BonusSettlementStatus.Draft]: 'app.bonusSettlement.status.draft',
    [BonusSettlementStatus.Sent]: 'app.bonusSettlement.status.sent',
    [BonusSettlementStatus.ReadyToComplete]: 'app.bonusSettlement.status.readyToComplete',
    [BonusSettlementStatus.Completed]: 'app.bonusSettlement.status.completed',
    [BonusSettlementStatus.Pending]: 'app.bonusSettlement.status.pending',
};

export const getBonusSettlementTranslationId = (status?: BonusSettlementStatus, type?: BonusSettlementType): string => {
    if (!status) {
        return translationObject[BonusSettlementStatus.Draft];
    }

    if (type === BonusSettlementType.Reclaim && status === BonusSettlementStatus.Sent) {
        return translationObject[BonusSettlementStatus.Pending];
    }

    return translationObject[status];
};
